const s = {
  name: "IndianRupee",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M14,11v2h5c1.3,0,2.4,0.8,2.8,2H14v2h7.8c-0.4,1.2-1.5,2-2.8,2h-5v2l6.3,7H23l-6.3-7H19c1.6,0,3.1-0.8,4-2
			c0.4-0.6,0.8-1.3,0.9-2H26v-2h-2.1c-0.1-0.7-0.5-1.4-0.9-2h3v-2H14z"/>
		<path class="st0" d="M20,0C9,0,0,9,0,20c0,11,9,20,20,20s20-9,20-20C40,9,31,0,20,0z M2,20c0-9.9,8.1-18,18-18s18,8.1,18,18
			s-8.1,18-18,18S2,29.9,2,20z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as IndianRupee
};
